import { useMFARedirect } from './hook';

export const MFARedirect = () => {
  const {} = useMFARedirect();
  return <></>;
};
